import { json } from 'react-router-dom';

import api from '.';

export const credentialsLoader = async (params) => {
  try{
    if(!params.slug) throw json({ msg: 'Debes ingresar un comercio' }, { status: 401 });

    return true;
  }catch (e) {
    throw json({ msg: `No se encontro el comercio ${params.slug} o es invalido.` });
  }
};

export const merchantLoader = async (params) => {
  try{
    const response = await api.get(`/merchants/${params.slug}`);

    if(response.status !== 200) throw new Response('Not Found error merchant', { status: 404 });

    return response.data;
  }catch (e) {
    throw new Response('Not Found error merchant', { status: 404, ...e });
  }
};

export const rootLoader = async ({params}) => {
  try{
    await credentialsLoader(params);
    const merchant = await merchantLoader(params);
    return merchant;
  }catch (e){
    throw json({ msg: `No se encontro el comercio ${params.slug} o es invalido.` }, { status: 404 });
  }
};

export const chainsLoader = async () => {
  try{
    const response = await api.get('/chains');
    if(response.status === 200){
      return response.data;
    }
    return false;
  }catch (e) {
    throw new Response('Not Found error chains', { status: 404, ...e });
  }
};

export const loaderProducts = async () => {
  try{
    const response = await api.get('/products');
    if(response.status === 200){
      return response.data?.results;
    }
    return false;
  }catch (e){
    throw new Response('Not Found error products', { status: 404, ...e });

  }
};